// Styles inlined into saved htmlContent — runtime PHP serves these as-is.

import {FormMakerFontFamily, FormMakerFontSize} from '@FormMakerReact/lib/form-maker-typography';

export const FORM_HEADING_TEXT_STYLES = {
  color: '#2C2B44',
  background: 'none',
  display: 'block',
  padding: '10px 0',
  margin: '0',
  width: 'auto',
  'box-sizing': 'border-box',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'letter-spacing': '0.03em',
  'font-size': FormMakerFontSize.PX_26,
  'font-weight': 'bold',
  'line-height': '150%',
  'font-family': FormMakerFontFamily.TAHOMA,
  'text-align': 'center',
  opacity: '100%',
  'border-color': '#FFFFFF',
  'min-width': '20px',
};

export const FORM_CONFIRMATION_HEADING_TEXT_STYLES = {...FORM_HEADING_TEXT_STYLES, 'font-size': FormMakerFontSize.PX_32};

export const FORM_DESCRIPTION_TEXT_STYLES = {
  color: '#2C2B44',
  background: 'none',
  display: 'block',
  padding: '0 0 10px 0',
  margin: '0',
  width: '100%',
  'box-sizing': 'border-box',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'letter-spacing': '0.03em',
  'font-size': FormMakerFontSize.PX_16,
  'font-weight': 'normal',
  'line-height': '150%',
  'font-family': FormMakerFontFamily.TAHOMA,
  'text-align': 'center',
  opacity: '100%',
  'border-color': '#FFFFFF',
  'min-width': '20px',
};

export const FORM_BUTTON_STYLES = {
  'background-color': '#3FBCE8',
  // border-style solid + width 0 lets the border-width preset show a border without also setting style.
  'border-style': 'solid',
  'border-width': '0',
  'border-color': '#FFFFFF',
  'border-radius': '6px',
  color: '#FFFFFF',
  padding: '15px',
  'font-size': FormMakerFontSize.PX_16,
  'letter-spacing': '0.03em',
  'line-height': '20px',
  margin: '0 0 0 auto',
  'white-space': 'break-spaces',
  'vertical-align': 'middle',
  'text-align': 'center',
  display: 'block',
  'font-family': FormMakerFontFamily.TAHOMA,
  opacity: '100%',
  cursor: 'pointer',
  width: '100%',
};

export const CONFIRMATION_PANEL_BUTTON_STYLES = {
  'background-color': '#3FBCE8',
  // border-style solid + width 0 lets the border-width preset show a border without also setting style.
  'border-style': 'solid',
  'border-width': '0',
  'border-color': '#FFFFFF',
  'border-radius': '8px',
  color: '#FFFFFF',
  padding: '16px 24px',
  'margin-top': '47px',
  'font-size': FormMakerFontSize.PX_16,
  'letter-spacing': '0.05em',
  'line-height': '24px',
  cursor: 'pointer',
  width: 'fit-content',
  'font-family': FormMakerFontFamily.TAHOMA,
  transition: 'background-color 0.2s ease',
};

export const FORM_WRAPPER_STYLES = {
  display: 'flex',
  'align-items': 'center',
  'justify-content': 'center',
  'min-height': '0 !important',
  padding: '0 !important',
  width: '100%',
  height: '100%',
};

// Bottom padding 94px reserves room for the absolutely-positioned submit-button-container.
export const FORM_BACKGROUND_STYLES = {
  background: '#FFFFFF',
  'background-color': '#FFFFFF',
  'box-shadow': '0 2px 16px rgba(20, 19, 37, 0.15)',
  display: 'flex',
  'flex-direction': 'column',
  'justify-content': 'space-around',
  padding: '24px 24px 94px',
  'min-height': '335px',
  'max-width': '500px',
  height: 'fit-content',
  margin: 'auto',
  width: '100%',
  'max-height': '80vh',
  'border-radius': '16px',
  'box-sizing': 'border-box',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'letter-spacing': '0.03em',
  'font-size': FormMakerFontSize.PX_16,
  'font-weight': 'normal',
  'line-height': '20px',
  'font-family': FormMakerFontFamily.TAHOMA,
  'text-align': 'left',
  opacity: '100%',
  'align-items': 'center',
  'overflow-y': 'auto',
};

export const FORM_SIGNUP_FORM_STYLES = {
  padding: '0',
  margin: '0',
  width: '100%',
  'max-width': '500px',
  position: 'relative',
  'border-radius': '16px',
  'border-width': '1px',
  'border-color': '#DCDCE1',
  'border-style': 'solid',
};

// display: contents — label is layout-invisible so the wrapper claims no space when
// its inner error-message-container is display:none; runtime JS still finds it by id.
export const FORM_LABEL_STYLES = {
  color: '#2C2B44',
  display: 'contents',
  margin: '0',
  width: 'auto',
  'box-sizing': 'border-box',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'letter-spacing': '0.03em',
  'font-size': FormMakerFontSize.PX_16,
  'font-weight': 'normal',
  'line-height': '20px',
  'font-family': FormMakerFontFamily.TAHOMA,
  'text-align': 'left',
  opacity: '100%',
  'border-color': '#FFFFFF',
};

export const FORM_POLICY_STYLES = {
  color: '#2C2B44',
  display: 'block',
  padding: '8px 0',
  margin: '0',
  width: '100%',
  'box-sizing': 'border-box',
  'letter-spacing': '0.05em',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'font-size': FormMakerFontSize.PX_12,
  'font-weight': 'normal',
  'line-height': '16px',
  'font-family': FormMakerFontFamily.TAHOMA,
  'text-align': 'left',
  opacity: '100%',
  'border-color': '#FFFFFF',
};

export const FORM_ERROR_MESSAGE_STYLES = {
  color: '#9C002F',
  display: 'block',
  padding: '8px 0',
  margin: '0',
  width: 'auto',
  'box-sizing': 'border-box',
  'letter-spacing': '0.05em',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'font-size': FormMakerFontSize.PX_12,
  'font-weight': 'normal',
  'line-height': '16px',
  'font-family': FormMakerFontFamily.TAHOMA,
  'text-align': 'left',
  opacity: '100%',
  'border-color': '#FFFFFF',
};

export const FORM_TEXT_STYLES = {
  color: '#2C2B44',
  display: 'block',
  padding: '8px 0',
  margin: '0',
  width: 'auto',
  'box-sizing': 'border-box',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'letter-spacing': '0.03em',
  'font-size': FormMakerFontSize.PX_16,
  'font-weight': 'normal',
  'line-height': '20px',
  'font-family': FormMakerFontFamily.TAHOMA,
  'text-align': 'left',
  opacity: '100%',
  'border-color': '#FFFFFF',
};

export const FORM_ICON_VECTOR_STYLES = {
  'pmw-icon-bg-fill': '#EBFBF7',
  'pmw-icon-check-fill': '#19AD89',
  width: 'fit-content',
  height: 'fit-content',
};

export const FORM_IMAGE_STYLES = {
  width: '100%',
  'max-width': '100%',
  display: 'block',
  height: 'auto',
  border: 'none',
};

export const FORM_SPACER_STYLES = {
  display: 'block',
  background: 'none',
  color: 'none',
  border: 'none',
  padding: '12px',
  width: '100%',
  height: 'auto',
};

export const FORM_ERROR_BOX_STYLES = {
  padding: '0',
  margin: '0',
  display: 'none',
};

export const FORM_ERROR_MESSAGE_CONTAINER_STYLES = {
  padding: '0',
  margin: '0',
  display: 'none',
  width: '100%',
};

export const FORM_CONFIRMATION_FORM_STYLES = {
  padding: '0',
  margin: '0',
  display: 'none',
  width: '100%',
};

export const FORM_INPUT_STYLES = {
  color: '#2C2B44',
  'background-color': '#FFFFFF',
  display: 'block',
  padding: '10px',
  margin: '0',
  width: '100%',
  'border-radius': '6px',
  'border-width': '1px',
  'border-style': 'solid',
  'border-color': '#CBCBD0',
  'box-sizing': 'border-box',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'letter-spacing': '0.03em',
  'font-size': FormMakerFontSize.PX_16,
  'font-weight': '300',
  'line-height': '20px',
  'font-family': FormMakerFontFamily.TAHOMA,
  'text-align': 'left',
  opacity: '100%',
};

export const PHONE_INPUT_STYLES = {
  ...FORM_INPUT_STYLES,
  'border-radius': '0px 6px 6px 0px',
  border: 'none',
  'border-left': 'solid 1px #CBCBD0',
};

export const PHONE_COUNTRY_CODE_STYLES = {
  ...FORM_INPUT_STYLES,
  border: 'none',
  'border-right': 'solid 8px transparent',
  width: '120px',
  'border-radius': '6px 0px 0px 6px',
};

export const PHONE_BOX_STYLES = {
  border: 'solid 1px #CBCBD0',
  'border-radius': '6px',
  display: 'flex',
};

export const FORM_EMAIL_STYLES = {
  margin: '0',
  width: '100%',
  height: '100%',
  padding: '0',
  'text-align': 'center',
  'border-color': '#FFFFFF',
  display: 'flex',
  'flex-direction': 'column',
  'justify-content': 'space-between',
};

export const FORM_ASTERISK_STYLES = 'margin-left: 4px; color: #D32559;';

export const SUBMIT_BUTTON_CONTAINER_STYLES = {
  position: 'absolute',
  bottom: '0',
  'border-radius': '0 0 12px 12px',
  padding: '24px',
  background: '#fff',
  left: '2px',
  width: 'calc(100% - 4px)',
  'box-sizing': 'border-box',
};
